var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcListingLegal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_listing_legal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-489.6 -249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector-2",
    "data-name": "Vector",
    transform: "translate(495.1 253)",
    fill: "none",
    stroke: "#909090",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5,0H14a3,3,0,0,1,3,3V19.5a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.7.6H14A2.4,2.4,0,0,1,16.4,3V19.3a.1.1,0,0,1-.1.1H.7a.1.1,0,0,1-.1-.1V.7A.1.1,0,0,1,.7.6Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0V1.8A1.805,1.805,0,0,0,1.8,3.6H3.6",
    transform: "translate(505.35 256.25)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H4.119",
    transform: "translate(499.461 263.9)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H8.238",
    transform: "translate(499.461 267.5)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcListingLegal);
export default __webpack_public_path__ + "static/media/ic_listing_legal.828d8d4d5a11ea783578532290eeb95a.svg";
export { ForwardRef as ReactComponent };